import * as Sentry from '@sentry/browser';
import Vue from 'vue';

const isProduction = process.env.VUE_APP_ENV === 'production';

Sentry.init({
  dsn: 'https://028ab6ae0167459b97a179c66906fd40@sentry.io/1375066',
  integrations: isProduction ? [new Sentry.Integrations.Vue({ Vue })] : [],
  beforeSend(event) {
    return isProduction ? event : null;
  },
});
